import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { formatAny } from '../../../utils/formatAny';

import Table from '../../../components/Table';
import Status from '../../components/Status';

const itemDefs = [
    {
        key: 'name',
        label: 'Name',
        value: 'name',
    },
    {
        key: 'image',
        label: 'Base Image',
        value: 'image',
    },
    {
        key: 'summaryCpu',
        label: 'CPU',
        itemContentRenderer: (item) => `${formatAny(item.cpu)}`,
    },
    {
        key: 'memory',
        label: 'Memory (G)',
        itemContentRenderer: (item) =>
            item.memory ? `${item.memory} G` : 'automatic G',
    },
    {
        key: 'vnc',
        label: 'VNC',
        itemContentRenderer: (item) => {
            const state = item.vncConsole === false ? 'disabled' : 'enabled';
            const status = item.vncConsole === false ? 'warning' : 'success';
            const title =
                item.vncConsole === false
                    ? 'Disable VNC console on VM'
                    : 'Enable VNC console on VM';
            return <Status title={title} label={state} variant={status} />;
        },
    },
];

const VmConfigsTable = ({ items, selectedItem, onSelect }) => (
    <Table
        primaryKey="name"
        items={items}
        itemDefinitions={itemDefs}
        selectedItem={selectedItem}
        onSelect={onSelect}
    />
);

VmConfigsTable.propTypes = {
    items: PropTypes.array,
    selectedItem: PropTypes.object,
    onSelect: PropTypes.func,
};

VmConfigsTable.defaultProps = {
    items: [],
    selectedItem: null,
    onSelect: noop,
};

export default VmConfigsTable;
